module.exports = __webpack_public_path__ + "static/sport/out2.0419485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/out2.png
// module id = WkiS
// module chunks = 0